module.exports = __webpack_public_path__ + "img/2.d42b89a4.png";